import React, { useState, useEffect } from 'react';
import Constant from '../Admin/AdminLayout';
import BreadScrum from '../Admin/BreadScrum';
import { Modal, Button } from 'react-bootstrap';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import Url from '../Element/Api';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { BounceLoader } from 'react-spinners';
import { css } from '@emotion/react';
import './ManageStaff.css';
import Select from 'react-select';

const StaffInfo = () => {
  const [staffData, setStaffData] = useState([]);
  const [response, setResponse] = useState([]);
  const [searchStaffByName, setSearhStaffByName] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [itemOffset, setItemOffset] = useState(1);
  const [searchClient, setSearchClient] = useState('');
  const [deleteRow, setDeleteRow] = useState([]);
  const [staffLists, setStaffLists] = useState([]);
  const [id, setId] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDate2, setSelectedDate2] = useState(null);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const modalClose = () => setShow3(false);
  const modalShow = () => setShow3(true);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const [brandIdToDelete, setBrandIdToDelete] = useState(null);
  const permissions = useSelector((state) => state.permissions);
  const type = useSelector((state) => state.type);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  // setPermission(useSelector((state) => state.permissions));
  console.log('permission..................------->>>>>>', permissions);
  const [isArrowObj, setIsArrowObj] = useState({
    column: 'name',
    orderby: 'desc'
  });
  const override = css`
    display: block;
    margin: 0 auto;
  `;
  const handleArrowClick = (param, orderby) => {
    if (isArrowObj && isArrowObj.column == param) {
      orderby = isArrowObj && isArrowObj.orderby == 'asc' ? 'desc' : 'asc';
    } else {
      orderby = orderby == 'asc' ? 'desc' : 'asc';
    }
    const isArrowobjData = {
      column: param,
      orderby: orderby
    };
    setIsArrowObj(isArrowobjData);
  };


  const handleDateChange = (date) => {
    // If selectedDate2 is set and is before the new selected date, reset both dates
    if (selectedDate2 && date >= selectedDate2) {
      setSelectedDate(null);
      setSelectedDate2(null);
    } else {
      setSelectedDate(date);
    }
  };

  const handleDateChange2 = (date) => {
    // If selectedDate is set and is after the new selected date, reset both dates
    if (selectedDate && date <= selectedDate) {
      // setSelectedDate(null);
      setSelectedDate2(null);
    } else {
      setSelectedDate2(date);
    }
  };
  const formattedDate = selectedDate ? format(selectedDate, 'dd/MM/yyyy') : '';
  const formattedDate2 = selectedDate2
    ? format(selectedDate2, 'dd/MM/yyyy')
    : '';

  const token = useSelector((state) => state.token);
  useEffect(() => {
    getBrandList();
  }, [
    searchClient,
    itemOffset,
    deleteRow,
    formattedDate,
    formattedDate2,
    isArrowObj,
    id,
    pageCount
  ]);

  const getBrandList = () => {
    setLoading(true);
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    axios
      .get(
        Url.BASEURL +
          'liststaff?' +
          'search=' +
          searchClient +
          '&page=' +
          itemOffset +
          '&staff_id=' +
          (id !== '' ? '&staff_id=' + id.value : '') +
          '&from=' +
          formattedDate +
          '&to=' +
          formattedDate2 +
          '&orderby=' +
          isArrowObj.column +
          '&sortby=' +
          isArrowObj.orderby,
        config
      )
      .then(
        (value) =>
          setStaffData(value.data.response.data) &
          console.log('staffdataaaaaaa', value.data.response.data) &
          setPageCount(value.data.response.last_page) &
          setLoading(false)
      )
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (staffData) {
      setResponse(staffData);
    }
  }, [staffData, searchClient]);

  // function for pagination
  const handlePageClick = (event) => {
    const newOffset = event.selected + 1;
    setItemOffset(newOffset);
  };

  // function for search
  const handleKeyPress = () => {
    setItemOffset(0);
    setSearhStaffByName(searchStaffByName);
  };

  // function for delete row
  const deleteRowHandler = (brandId) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    const params = {
      id: brandId
    };
    axios
      .delete(Url.BASEURL + 'deletestaff/' + brandIdToDelete, config, params)
      .then((value) => {
        setDeleteRow(value.data.response);
        getBrandList();
      })
      .catch((err) => console.log(err));
  };

  // const StaffChangeHandler = (event) => {
  //   setId(event.target.value);
  // };

  useEffect(() => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    axios
      .get(Url.BASEURL + 'staffsdropdown', config)
      .then(
        (value) =>
          setStaffLists(value.data) &
          setPageCount(value.data.response.last_page)
      )
      .catch((err) => console.log(err));
  }, []);

  // to format date
  const formatDate = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based, so we add 1.
      const year = date.getFullYear().toString();
      return `${day}-${month}-${year}`;
    }
    return '';
  };
  const transformClientDataToOptions = (data) => {
    const selectOption = { value: '', label: 'Select Staff' };
    const dataOptions = data.map(({ id, name, email }) => ({
      value: id.toString(),
      label: `${name} (${email})`
    }));
    return [selectOption, ...dataOptions];
  };
  const staffOptions = transformClientDataToOptions(staffLists);
  const handleClearInput = () => {
    setSearchClient('');
  };
  const toggleCalendar = () => {
    setIsCalendarOpen(!isCalendarOpen);
  };
  return (
    <>
      <Constant>
        <BreadScrum
          btn_name="Add Staff"
          routepath={'addstaff'}
          heading={'Manage Staff'}
          btn={'Add Staff'}
          bgColor={'#1E336A'}
          text_color={'#FFFFFF'}
          disabled={
            type === 'superadmin' || permissions?.Manage_Staff?.includes('add')
              ? false
              : true
          }
        />{' '}
        <div>
          <div>
            <Modal
              show={show3}
              onHide={modalClose}
              backdrop={'static'}
              keyboard={false}
              centered
            >
              <Modal.Header
                closeButton
                style={{
                  backgroundColor: '#1e336a',
                  color: 'white',
                  border: 'none'
                }}
              >
                <Modal.Title>Staff Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <staffModal />
              </Modal.Body>
            </Modal>
          </div>
          <section className="content section_padding">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    {/* /.card-header */}
                    <div
                      className="card-body table-responsive"
                      style={{
                        overflow: 'hidden',
                        minHeight: isCalendarOpen ? '320px' : null
                      }}
                    >
                      <div
                        className="search-field d-none d-md-block"
                        style={{ marginBottom: '13px' }}
                      >
                        <div className="">
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              flexWrap: 'wrap',
                              alignItems: 'center'
                            }}
                          >
                            <div>
                              <div
                                className=" position-relative"
                                style={{
                                  borderWidth: 1,
                                  borderRadius: 5,
                                  border: '1px solid black'
                                }}
                              >
                                <input
                                  style={{
                                    height: 30,
                                    paddingRight: 30
                                  }}
                                  onChange={(e) =>
                                    setSearchClient(e.target.value) &
                                    handleKeyPress()
                                  }
                                  type="text"
                                  className="form-control bg-transparent border-0"
                                  placeholder="Search"
                                  value={searchClient}
                                />
                                {searchClient && (
                                  <span
                                    className="position-absolute top-50 end-0 translate-middle-y"
                                    style={{
                                      cursor: 'pointer',
                                      marginRight: 10
                                    }}
                                    onClick={handleClearInput}
                                  >
                                    ✕
                                  </span>
                                )}
                              </div>
                            </div>

                            <div>
                              <label className="p-2 m-0">From :</label>
                              <DatePicker
                                selected={selectedDate}
                                onChange={handleDateChange}
                                dateFormat="dd-MM-yyyy"
                                placeholderText="Select a date"
                                onKeyDown={(e) =>
                                  e.key === 'Backspace' && e.preventDefault()
                                }
                                maxDate={new Date()}
                                isClearable={true}
                                onCalendarOpen={toggleCalendar}
                                onCalendarClose={toggleCalendar}
                                yearDropdown
                                scrollableYearDropdown
                                showYearDropdown={true}
                              />
                            </div>
                            <div
                            // style={{ display: 'flex', flexDirection: 'column' }}
                            >
                              <label className="p-2 m-0">To :</label>
                              <DatePicker
                                selected={selectedDate2}
                                onChange={handleDateChange2}
                                dateFormat="dd-MM-yyyy"
                                placeholderText="Select a date"
                                onKeyDown={(e) =>
                                  e.key === 'Backspace' && e.preventDefault()
                                }
                                maxDate={new Date()}
                                isClearable={true}
                                onCalendarOpen={toggleCalendar}
                                onCalendarClose={toggleCalendar}
                                yearDropdown
                                scrollableYearDropdown
                                showYearDropdown={true}
                              />
                            </div>
                            <Select
                              style={{ width: '200px' }}
                              defaultValue={id}
                              onChange={setId}
                              options={staffOptions}
                              placeholder="Select Staff"
                              maxMenuHeight="200px" // Set the minimum height here
                              // minMenuHeight="180px"
                              styles={{
                                container: (provided, state) => ({
                                  ...provided,
                                  width: '250px' // Set the width here
                                })
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="wrapper">
                        {loading ? (
                          <div
                            className="spinner-container"
                            style={{ marginLeft: '500px' }}
                          >
                            <BounceLoader
                              color={'#123abc'}
                              loading={loading}
                              css={override}
                              size={60}
                            />
                          </div>
                        ) : (
                          <table
                            id="example2"
                            className="table table-bordered table-hover"
                            style={{ fontSize: '14px' }}
                          >
                            <thead>
                              <tr>
                                {/* <th>Sr. No</th> */}
                                <th className="tableheadstaff">
                                  <span style={{ marginRight: '3px' }}>
                                    <i
                                      onClick={() =>
                                        handleArrowClick('name', 'asc')
                                      }
                                      class={
                                        isArrowObj &&
                                        isArrowObj.column == 'name' &&
                                        isArrowObj.orderby == 'desc'
                                        ?'fa fa-arrow-up'
                                        : 'fa fa-arrow-down'
                                      }
                                      style={{ color: 'grey' }}
                                    ></i>
                                  </span>
                                  Staff Name
                                </th>
                                <th className="tableheadstaff">
                                  <span style={{ marginRight: '3px' }}>
                                    <i
                                      onClick={() =>
                                        handleArrowClick('email', 'asc')
                                      }
                                      class={
                                        isArrowObj &&
                                        isArrowObj.column == 'email' &&
                                        isArrowObj.orderby == 'desc'
                                          ? 'fa fa-arrow-down'
                                          : 'fa fa-arrow-up'
                                      }
                                      style={{ color: 'grey' }}
                                    ></i>
                                  </span>
                                  Email
                                </th>
                                <th className="tableheadstaff">
                                  <span style={{ marginRight: '3px' }}>
                                    <i
                                      onClick={() =>
                                        handleArrowClick('contact_no', 'asc')
                                      }
                                      class={
                                        isArrowObj &&
                                        isArrowObj.column == 'contact_no' &&
                                        isArrowObj.orderby == 'desc'
                                          ? 'fa fa-arrow-down'
                                          : 'fa fa-arrow-up'
                                      }
                                      style={{ color: 'grey' }}
                                    ></i>
                                  </span>
                                  Contact Number
                                </th>
                                <th className="tableheadstaff">
                                  <span style={{ marginRight: '3px' }}>
                                    <i
                                      onClick={() =>
                                        handleArrowClick('designation', 'asc')
                                      }
                                      class={
                                        isArrowObj &&
                                        isArrowObj.column == 'designation' &&
                                        isArrowObj.orderby == 'desc'
                                          ? 'fa fa-arrow-down'
                                          : 'fa fa-arrow-up'
                                      }
                                      style={{ color: 'grey' }}
                                    ></i>
                                  </span>
                                  Designation
                                </th>

                                <th className="tableheadstaff">
                                  {/* <span style={{ marginRight: '3px' }}>
                                    <i
                                      onClick={() =>
                                        handleArrowClick('clientname', 'asc')
                                      }
                                      class={
                                        isArrowObj &&
                                          isArrowObj.column == 'clientname' &&
                                          isArrowObj.orderby == 'desc'
                                          ? 'fa fa-arrow-down'
                                          : 'fa fa-arrow-up'
                                      }
                                      style={{ color: 'grey' }}
                                    ></i>
                                  </span> */}
                                  Team Manager/Staff
                                </th>
                                <th className="tableheadstaff">Team Manager</th>
                                <th className="tableheadstaff">
                                  {/* <span style={{ marginRight: '3px' }}>
                                    <i
                                      onClick={() =>
                                        handleArrowClick('clientname', 'asc')
                                      }
                                      class={
                                        isArrowObj &&
                                          isArrowObj.column == 'clientname' &&
                                          isArrowObj.orderby == 'desc'
                                          ? 'fa fa-arrow-down'
                                          : 'fa fa-arrow-up'
                                      }
                                      style={{ color: 'grey' }}
                                    ></i>
                                  </span> */}
                                  Active/Non-active
                                </th>

                                <th className="tableheadstaff">
                                  <span style={{ marginRight: '3px' }}>
                                    <i
                                      onClick={() =>
                                        // handleArrowClick('created_at', 'asc')
                                        handleArrowClick('join_date', 'asc')
                                      }
                                      class={
                                        isArrowObj &&
                                        isArrowObj.column == 'join_date' &&
                                        isArrowObj.orderby == 'desc'
                                          ? 'fa fa-arrow-down'
                                          : 'fa fa-arrow-up'
                                      }
                                      style={{ color: 'grey' }}
                                    ></i>
                                  </span>
                                  Joining Date
                                </th>
                                {type === 'superadmin' ||
                                permissions?.Manage_Staff?.includes('view') ||
                                permissions?.Manage_Staff?.includes('update') ||
                                permissions?.Manage_Staff?.includes(
                                  'delete'
                                ) ? (
                                  <th className="tableheadstaff">Action</th>
                                ) : null}
                              </tr>
                            </thead>
                            <tbody>
                              {staffData.length == 0 ? (
                                <tr className="text-center">
                                  <td
                                    colSpan="9"
                                    style={{ fontSize: 16, marginTop: '10px' }}
                                  >
                                    No Record found
                                  </td>
                                </tr>
                              ) : (
                                <>
                                  {staffData.map((e, index) => {
                                    return (
                                      <tr className="tablerow">
                                        {/* <td>{index + 1}</td> */}

                                        <td>{e.name ? e.name : ''}</td>
                                        <td>{e.email ? e.email : ''}</td>
                                        <td>
                                          {e.contact_no ? e.contact_no : ''}
                                        </td>
                                        <td>
                                          {e.designationdata &&
                                          e.designationdata.designation
                                            ? e.designationdata.designation
                                            : ''}
                                        </td>

                                        <td>
                                          {e.manager_status === 1
                                            ? 'Team Manager'
                                            : 'Staff'}
                                        </td>
                                        <td>
                                          {e.team_manager && e.team_manager.name
                                            ? e.team_manager.name
                                            : '--'}
                                        </td>
                                        <td>
                                          {e.enabled === 1
                                            ? 'Active'
                                            : 'Not-Active'}
                                        </td>
                                        <td>{formatDate(e.join_date)}</td>
                                        {type === 'superadmin' ||
                                        permissions?.Manage_Staff?.includes(
                                          'view'
                                        ) ||
                                        permissions?.Manage_Staff?.includes(
                                          'update'
                                        ) ||
                                        permissions?.Manage_Staff?.includes(
                                          'delete'
                                        ) ? (
                                          <td>
                                            <div className="actionstaff d-flex justify-content-between align-items-center">
                                              {type === 'superadmin' ||
                                              permissions?.Manage_Staff?.includes(
                                                'view'
                                              ) ? (
                                                <Link
                                                  to={'/staffDetails/' + e.id}
                                                  className="nav-icon fa-solid fa-eye pointer_cursor d-block p-1"
                                                ></Link>
                                              ) : null}
                                              {type === 'superadmin' ||
                                              permissions?.Manage_Staff?.includes(
                                                'update'
                                              ) ? (
                                                <Link
                                                  to={'/managestaff/' + e.id}
                                                  className="nav-icon fas fa-edit pointer_cursor d-block p-1"
                                                ></Link>
                                              ) : null}
                                              {type === 'superadmin' ||
                                              permissions?.Manage_Staff?.includes(
                                                'delete'
                                              ) ? (
                                                <i
                                                  onClick={() => {
                                                    handleShow();
                                                    setBrandIdToDelete(e.id);
                                                  }}
                                                  className="nav-icon fas fa-times pointer_cursor d-block p-1"
                                                />
                                              ) : null}
                                            </div>
                                          </td>
                                        ) : null}
                                      </tr>
                                    );
                                  })}
                                </>
                              )}
                            </tbody>
                          </table>
                        )}
                        <ReactPaginate
                          previousLabel="Previous"
                          nextLabel="Next"
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          breakLabel="..."
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          pageCount={pageCount}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={5}
                          containerClassName="pagination"
                          activeClassName="active"
                          onPageChange={handlePageClick}
                        />
                      </div>
                    </div>
                    {/* /.card-body */}
                  </div>
                  {/* /.card */}
                  {/* /.card */}
                </div>
                {/* /.col */}
              </div>
              {/* /.row */}
            </div>
            {/* /.container-fluid */}
          </section>
        </div>
      </Constant>
      {show && (
        <Modal
          show={show}
          onHide={handleClose}
          backdrop={'static'}
          keyboard={false}
          centered
        >
          <Modal.Header
            closeButton
            style={{
              backgroundColor: '#1e336a',
              color: 'white',
              border: 'none'
            }}
          >
            <Modal.Title>Delete Staff</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ fontSize: '20px' }}>
            Are you sure you want to delete the Staff?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button
              style={{ backgroundColor: '#1E3F6A', border: 'none' }}
              onClick={() => {
                handleShow2();
                handleClose();
                deleteRowHandler();
              }}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {show2 && (
        <Modal
          show={show2}
          onHide={handleClose2}
          backdrop={'static'}
          keyboard={false}
          centered
        >
          <Modal.Header
            closeButton
            style={{
              backgroundColor: '#1e336a',
              color: 'white',
              border: 'none'
            }}
          >
            <Modal.Title>Delete Staff</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ fontSize: '20px' }}>
            Staff Deleted Sucessfully.
          </Modal.Body>
          <Modal.Footer>
            <Button
              style={{ backgroundColor: '#1E3F6A', border: 'none' }}
              onClick={handleClose2}
            >
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};
export default StaffInfo;
